<template>
  <a href="https://wa.me/51906610586?text= Hola Héroes Digitales!" class="group fixed bottom-4 right-4 bg-green-500 px-4 py-4 rounded-xl flex flex-row items-center justify-center text-white transition-all z-50">
    <i :class="`fa-brands fa-whatsapp text-4xl group-hover:mr-2`"/>
    <span class="hidden group-hover:block fmain font-bold text-xl transition-opacity duration-300 ease-in-out">Hablemos!</span>
  </a>
  <router-view/>
</template>
